import { UnitConverter } from '../base/UnitConverter';
import { CountPolicy } from '../policy';
import { QuantityResult } from '../types';
import { UnitOptions } from '../constants/unit.options';

export class GeneralUnitConverter extends UnitConverter<
  | (typeof UnitOptions)['APM'][number]['value']
  | (typeof UnitOptions)['Cache'][number]['value']
  | (typeof UnitOptions)['DB'][number]['value']
  | (typeof UnitOptions)['Disk'][number]['value']
  | (typeof UnitOptions)['General'][number]['value']
  | (typeof UnitOptions)['Logging'][number]['value']
  | (typeof UnitOptions)['Memory'][number]['value']
  | (typeof UnitOptions)['Network'][number]['value']
  | (typeof UnitOptions)['Synthetic'][number]['value']
  | (typeof UnitOptions)['System'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: GeneralUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): GeneralUnitConverter {
    if (!GeneralUnitConverter.instance) {
      GeneralUnitConverter.instance = new GeneralUnitConverter();
    }
    return GeneralUnitConverter.instance;
  }

  protected units = [
    ...UnitOptions.APM.map(({ value }) => value),
    ...UnitOptions.Cache.map(({ value }) => value),
    ...UnitOptions.DB.map(({ value }) => value),
    ...UnitOptions.Disk.map(({ value }) => value),
    ...UnitOptions.General.map(({ value }) => value),
    ...UnitOptions.Logging.map(({ value }) => value),
    ...UnitOptions.Memory.map(({ value }) => value),
    ...UnitOptions.Network.map(({ value }) => value),
    ...UnitOptions.Synthetic.map(({ value }) => value),
    ...UnitOptions.System.map(({ value }) => value),
  ];

  protected unitToBase = this.units.reduce<Record<string, number>>((acc, unit) => {
    acc[unit] = 1;
    return acc;
  }, {});

  override convertToBestUnit(
    value: number,
    fromUnit: string,
    countPolicy?: CountPolicy,
  ): QuantityResult {
    const policy = this.resolveCountPolicy(countPolicy);
    return policy(value, fromUnit);
  }

  override convertToUnit(
    value: number,
    fromUnit: string,
    toUnit: string,
    countPolicy?: CountPolicy,
  ): QuantityResult {
    const policy = this.resolveCountPolicy(countPolicy);
    return policy(value, toUnit);
  }

  override convertToLargerBestUnit(
    value: number,
    fromUnit: string,
    countPolicy?: CountPolicy,
  ): QuantityResult {
    const policy = this.resolveCountPolicy(countPolicy);
    return policy(value, fromUnit);
  }
}
